import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProgressBar from './ProgressBar';
import { Button } from '../ui/button';
import { ArrowLeft } from 'lucide-react';
import GlassCard from '../GlassCard';

const WizardLayout = ({ 
  currentStep, 
  children, 
  onBack, 
  onNext, 
  nextLabel = "Next",
  nextDisabled = false,
  showBack = true 
}) => {
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      {/* Main wizard card */}
      <GlassCard className="p-8">
        <ProgressBar currentStep={currentStep} />
        
        {/* Content */}
        <div className="mb-8">
          {children}
        </div>
        
        {/* Navigation */}
        <div className="flex justify-between items-center pt-6 border-t border-gray-200 dark:border-dark-border">
          {showBack && onBack ? (
            <Button
              type="button"
              variant="outline"
              onClick={onBack}
              className="rounded-xl"
            >
              ← Back
            </Button>
          ) : (
            <div />
          )}
          
          <Button
            type="button"
            onClick={onNext}
            disabled={nextDisabled}
            className="gradient-primary text-white rounded-xl px-8"
          >
            {nextLabel} →
          </Button>
        </div>
      </GlassCard>
    </div>
  );
};

export default WizardLayout;
